'use strict';

customerZone

    /**
     * Client for the Unleased Web Api (UWA)
     */
    .service('UnleashedClient', ['$http', '$q', '$filter', '$timeout', '$log', 'config', 'utils', 'errorCode',
        'RestClientBase',
        function($http, $q, $filter, $timeout, $log, config, utils, errorCode, RestClientBase){

            var base = new RestClientBase(config.unleashedApi.endpoint);

            //*** Mapping functions  ---------------------------------------------------------------------------------//

            var mapBalanceToModel = function(payload){

                var typeMappers = {
                    'value': {unit: 'unit_euros', map: function(value){ return value; }},
                    'data': {unit: 'unit_megabytes', map: function(value){ return Math.floor(value / 1024 / 1024); }},
                    'sms': {unit: 'unit_messages', map: function(value){ return value; }},
                    'voice': {unit: 'unit_minutes', map: function(value){ return Math.floor(value / 60); }},
                    'voice_off_net': {unit: 'unit_minutes', map: function(value){ return Math.floor(value / 60); }},
                    'voice_on_net': {unit: 'unit_minutes', map: function(value){ return Math.floor(value / 60); }},
                    'data_roaming': {unit: 'unit_megabytes', map: function(value){
                        return Math.round(value / 1024 / 1024);
                    }}
                };

                var mapBundleToModel = function(item){

                    var bundle ={};

                    bundle.product = {
                        title: item.descriptions.title,
                        description: item.descriptions.description
                    };

                    bundle.startDate = base.parseDate(item.valid_from);
                    bundle.endDate = base.parseDate(item.valid_until);
                    bundle.totalAmount = item.total;
                    bundle.remainingAmount = item.remaining;

                    var type = item.type;
                    var mapper = typeMappers[type];
                    if (!mapper){
                        $log.error('Unsupported bundle type: '+type);
                        return bundle;
                    }

                    bundle.type = type;
                    bundle.unit = mapper.unit;
                    bundle.totalAmount = mapper.map(bundle.totalAmount);
                    bundle.remainingAmount = mapper.map(bundle.remainingAmount);

                    return bundle;
                };

                return {
                    credit: payload.credit,
                    outOfBundle: payload['out_of_bundle_cost'],
                    bundles: payload.bundles ? payload.bundles.map(mapBundleToModel) : []
                };
            };

            var mapCustomerFromModel = function(model){

                var mapCompany = function(name, vat){
                    if (!name && !vat) return undefined;
                    return {
                        'company_name': name,
                        'vat_number': vat
                    };
                };

                var result = {
                    'first_name': model.firstName,
                    'last_name': model.lastName,
                    'date_of_birth': base.formatDate(model.birthDate),
                    'place_of_birth': model.birthPlace,
                    'email': model.email,
                    'language': model.language || currentLanguage(),
                    'gender': {'Mr': 'M', 'Mrs': 'F'}[model.title],
                    'address': mapAddressFromModel(model.address),
                    'company': mapCompany(model.company, model.vat),
                    'password': model.password
                };

                return base.removeUndefined(result);
            };

            var mapCustomerToModel = function(payload){
                var result = {
                    id: payload.id,
                    email: payload.email,
                    firstName: payload['first_name'],
                    lastName: payload['last_name'],
                    language: payload.language,
                    birthDate: base.parseDate(payload['date_of_birth']),
                    birthPlace: payload['place_of_birth'],
                    title: {'M': 'Mr', 'F': 'Mrs'}[payload.gender],
                    passwordLeaked: payload.password_leaked
                };

                var registration = payload['prepaid_registration'];
                if (registration){
                    result.verificationState = registration['verification_state'];
                    if (result.verificationState === 'temporarily_verified') {
                        result.verifiedUntil = moment(registration['verified_until']);
                    }
                }

                if (payload.company) {
                    result.vat = payload.company['vat_number'];
                    result.company = payload.company['company_name'];
                }

                if (payload.dateofbirth)
                    result.birthDate = payload.dateofbirth;

                if (payload.address)
                    result.address = {
                        street: payload.address.street,
                        number: payload.address.number,
                        box: payload.address.box,
                        city: payload.address.city,
                        postcode: payload.address.postcode,
                        country: payload.address.country
                    };
                return result;
            };

            var mapAddressFromModel = function(model){
                if (!model) return undefined;
                return base.removeUndefined({
                    street: model.street,
                    number: model.number,
                    box: model.box || undefined,
                    city: model.city,
                    postcode: model.postcode,
                    country: model.country || 'be'
                });
            };

            var mapSimToModel = function(payload){

                var determineSimState = function(payloadState){
                    if (payloadState === 'suspended') return 'user_blocked';
                    else if (payloadState === 'enabled') return 'active';
                    else return payloadState;
                };

                return {
                    pin1: payload.pin1,
                    pin2: payload.pin2,
                    puk1: payload.puk1,
                    puk2: payload.puk2,
                    iccid: payload.iccid,
                    state: determineSimState(payload.state)
                };
            };

            /**
             * Map a subscription to the model, and return a promise.
             */
            var mapSubscriptionToModel = function(payload){

                var stateMappings = {
                    'deactivated': jim.SubscriptionState.disabled
                };

                var result = new jim.Subscription({
                    id: payload.id,
                    productId: payload['product_id'],
                    product: mapInlineProductToModel(payload.product),
                    state: stateMappings[payload.state] || payload.state,
                    type: payload.type ? payload.type.toUpperCase() : undefined,
                    msisdn: payload.sim ? payload.sim.msisdn : undefined,
                    alias: payload.sim ? ignoreDummyAlias(payload.sim.alias, payload.sim.msisdn): undefined,
                    validFrom: moment.utc(payload['valid_from'], 'YYYY-MM-DD'),
                    validUntil: moment.utc(payload['valid_until'], 'YYYY-MM-DD')
                });

                if (payload.sim) result.sim = mapSimToModel(payload.sim);
                if (payload['pending_product']) result.pendingProduct = {
                    product: mapInlineProductToModel(payload['pending_product'].product),
                    validFrom: moment.utc(payload['pending_product']['valid_from'], 'YYYY-MM-DD')
                };

                if (payload.state === jim.SubscriptionState.disabled) {
                    return self.getPendingOrders(result.id)
                        .then(function(orders){
                            var pendingOrders = orders
                                .filter(isSubscriptionOrder);

                            if (pendingOrders.length > 0) {
                                result.state = jim.SubscriptionState.pending;
                                result.order = pendingOrders[0];
                            }
                            return result;
                        });
                }
                return $q.when(result);
            };

            var ignoreDummyAlias = function(value, msisdn){
                if (!value) return value;
                if (/\s*null\s*null\s*|^\s*-\s*/.test(value)) return undefined;
                if (value === msisdn) return undefined;
                return value;
            };

            var isSubscriptionOrder = function(order){
                for (var i=0; i<order.products.length; i++){
                    if (order.products[i].type === jim.ProductType.prepaid_subscription) return true;
                    if (order.products[i].type === jim.ProductType.postpaid_subscription) return true;
                }
                return false;
            };

            var mapShipmentInfoToModel = function(payload){
                if (!payload) return undefined;
                return {
                    firstName: payload['first_name'],
                    lastName: payload['last_name'],
                    company: payload['company_name'],
                    address: payload.address
                };
            };

            var mapShipmentInfoFromModel = function(model){
                return {
                    'address': mapAddressFromModel(model.address),
                    'first_name': model.firstName,
                    'last_name': model.lastName,
                    'company_name': model.company
                };
            };

            var mapSwapStateToModel = function(payload){
                var result = {
                    reason: payload.reason,
                    paymentUrl: payload.payment_url,
                    shipmentInfo: mapShipmentInfoToModel(payload.shipping_info.address)
                };

                if (payload.payment_url) result.paymentUrl = payload.payment_url;

                return result;
            };

            var mapInvoiceToModel = function(payload){
                var paid = payload['status'] === 'paid' || payload['status'] === 'pending_payment';
                return {
                    id: payload.id,
                    number: payload.number,
                    date: base.parseDate(payload.date),
                    amount: payload.amount,
                    amountDue: payload['amount_due'] || (paid ? 0 : payload.amount),
                    paid: paid,
                    pdf: base.url('invoices/{}/pdf', payload.id),
                    refNum: payload['reference_number']
                };
            };

            var mapTopupToModel = function(payload) {
                return {
                    date: base.parseDateTime(payload['date_updated']),
                    amount: payload['amount'],
                    state: payload['status']
                };
            };

            var mapUsageRecordToModel = function(payload){
                return {
                    type: payload['traffic_type'],
                    startDate: base.parseDateTime(payload['start_timestamp']),
                    time: payload.duration,
                    origin: removePhonePrefix(payload.origin),
                    destination: removePhonePrefix(payload.destination),
                    isIncoming: payload['is_incoming'],
                    price: payload.price,
                    quantity: payload.quantity
                };
            };

            var mapUsageTotalsToModel = function(payload){

                /** For the records of given trafficType and directin, return the sum of the requested term,
                 *  and the sum of the cost */
                var records = function(trafficType, direction, term, resultTerm) {

                    var reduced = payload
                        .filter(function(record) { return record.trafficType === trafficType; })
                        .filter(function(record) { return direction === 'out' ^ record.incoming; })
                        .map(function(record) { return {amount: record[term], cost: record.totalPrice}; })
                        .reduce(
                            function(a, b) { return {amount: a.amount + b.amount, cost: a.cost + b.cost}; },
                            {amount: 0, cost: 0});

                    var result = {cost: reduced.cost};
                    result[resultTerm] = reduced.amount;
                    return result;
                };

                return {
                    voice: {
                        in: records('voice', 'in', 'totalDuration', 'duration'),
                        out: records('voice', 'out', 'totalDuration', 'duration')
                    },
                    sms: {
                        in: records('sms', 'in', 'totalQuantity', 'count'),
                        out: records('sms', 'out', 'totalQuantity', 'count')
                    },
                    data: {
                        out: records('data', 'out', 'totalQuantity', 'megs')
                    }
                };
            };

            var mapProductToModel = function(payload){
                var data = {
                    id: payload.id,
                    type: payload.type,
                    name: payload.descriptions ? payload.descriptions.title : undefined,
                    description: payload.descriptions ? payload.descriptions.description : undefined,
                    category: payload.descriptions ? payload.descriptions.category : undefined,
                    price: payload.price,
                    monthlyFee: payload['product_definitions'] && payload['product_definitions']['rates']  ?
                        (payload['product_definitions']['rates']['per_month'] || 0) : 0,
                    available: payload.available,
                };
                try {
                    var complexDescription = JSON.parse(data.description);
                    data.bonus = complexDescription.bonus;
                    data.description = complexDescription.description;
                }
                catch (e){
                    // product does not have a complex description -- ignore
                }

                return jim.Product.fromProperties(data);
            };

            var mapOrderToModel = function(payload){
                if (!payload) return null;
                var r = base.snakeToCamel(payload);
                r.products = r.products.map(mapProductToModel);
                r.type = determineOrderType(r);
                r.dateCreated = base.parseDateTime(r.dateCreated);
                r.dateUpdated = base.parseDateTime(r.dateUpdated);
                r.state = r.status; delete r.status;
                if (r.donor) r.donor = mapMnpDetailsToModel(r.donor);
                return r;
            };

            var mapMnpDetailsToModel = function(payload){
                if (!payload) return null;
                return {
                    msisdn: payload.msisdn,
                    donorIccid: payload.iccid,
                    donorOperator: {id: payload.operator},
                    donorType: payload.requestType
                };
            };

            var mapMnpDetailsFromModel = function(details){
                if (!details) return null;
                return {
                    'msisdn': details.msisdn,
                    'iccid': details.donorIccid,
                    'operator': details.donorOperator ? details.donorOperator.id : undefined,
                    'request_type': details.donorType
                };
            };

            var removePhonePrefix = function(number){
                if (!number) return number;
                return number.replace(/^00|^\+/, '');
            };

            /**
             * Takes products from an order and determines which type of order it is.
             */
            var determineOrderType = function(order){
                if ([
                    jim.OrderType.TERMINATE_CONTRACT,
                    jim.OrderType.SIM_ACTIVATION,
                    jim.OrderType.ORDER_A_SWAP,
                    jim.OrderType.UNKNOWN_ORDER,
                    jim.OrderType.ORDER_A_LIGHT_TO_FULL_MIGRATION,
                    jim.OrderType.SILENT_IMSI_SWAP
                ].includes(order.type))
                    return order.type;

                if (order.type === 'create_contract')
                    return jim.OrderType.ORDER_A_SIM;
                if (['modify_postpaid_tariff_plan', 'switch_between_prepaid_and_postpaid'].includes(order.type))
                    return jim.OrderType.ORDER_A_MIGRATION;
                var productsType = order.products.map(function(product){
                    return product.type;
                });
                if (productsType.length === 1 && productsType.indexOf('prepaid/topup') > -1)
                    return jim.OrderType.ORDER_A_TOPUP;
                if (productsType.indexOf('prepaid/package') > -1)
                    return jim.OrderType.ORDER_A_PACKAGE;
                if (productsType.indexOf('postpaid/package') > -1)
                    return jim.OrderType.ORDER_A_PACKAGE;
                $log.debug('Failed to map order', order);
                $log.error('undefined type of order');
                return '';
            };

            var mapInlineProductToModel = function(data){

                var giveMeTheMarketingUrl = function(product){
                    if (product.type === 'prepaid') return config.mainUrls.prepaid;
                    if (product.type === 'postpaid') {
                        if (/2350970|2350972|2350974/.exec(product.id)) return config.mainUrls.subscriptions;
                        else return config.mainUrls.legacySubscriptions;
                    }
                };

                if (!data) return null;
                return jim.Product.fromProperties({
                    id: data.id,
                    price: data.price,
                    type: data.type,
                    name: data.descriptions ? data.descriptions.title : undefined,
                    available: data.available,
                    marketingUrl: giveMeTheMarketingUrl(data)
                });
            };

            //*** Back to the service  -------------------------------------------------------------------------------//

            var self = this;
            var httpConfig = {
                headers: {
                    'Accept-Language': config.language.substr(0, 2)
                },
                //TODO: set this to a reasonable http timeout as soon as stats prove we can.
                timeout: 60000
            };

            /**
             * Fetch balance for the given subscription id
             * @param subscriptionId
             * @returns balance credit as a promise
             */
            self.getBalance = function(subscriptionId){

                checkRequiredParams({subscriptionId: subscriptionId});

                return $http.get(base.url('subscriptions/{}/balance', subscriptionId), httpConfig)
                    .then(function(response){
                        return mapBalanceToModel(response.data);
                    }, function(response){
                        if (response.status === 404)
                            return {};
                        if (response.status === 502)
                            throw errorCode.wrap(errorCode.BAD_GATEWAY);
                        base.unwrapError(response);
                    });
            };

            /**
             * Log in with a given username and password.
             *
             * @return a Promise that will resolve if login is complete.
             * If the promise is rejected, check the errorCode for 'INVALID_GRANT'
             */
            self.getToken = function(username, password){

                checkRequiredParams({username: username, password: password});

                return $http.post(
                    config.unleashedApi.endpoint+'/oauth2/token/',
                    {
                        'username': username,
                        'password': password,
                        'grant_type': 'password',
                        'client_id': config.unleashedApi.authClientId
                    },
                    base.asUrlFormEncoded(httpConfig)
                ).then(
                    function(response){ //success
                        return {
                            token: response.data.access_token,
                            refreshToken: response.data.refresh_token,
                            profile: profileFromToken(response.data.access_token)
                        };
                    },
                    function(response) { //failure
                        if (response.status === 400 || response.status === 401)
                            throw errorCode.wrap(errorCode.INVALID_GRANT, response.data['error_description']);
                        if (response.status === 403)
                            throw response.data;
                        else
                            base.unwrapError(response);
                    });
            };

            self.refreshToken = function(username, refreshToken){

                checkRequiredParams({username: username, refreshToken: refreshToken});

                var fail = function(message, errorDescription){
                    var result = {message: message};
                    if (errorDescription)
                        result.errorDescription = errorDescription;
                    return $q.reject(result);
                };

                return $http.post(
                    config.unleashedApi.endpoint+'/oauth2/token/',
                    {
                        'username': username,
                        'refresh_token': refreshToken,
                        'grant_type': 'refresh_token',
                        'client_id': config.unleashedApi.authClientId
                    },
                    base.asUrlFormEncoded(httpConfig)
                ).then(
                    function(response){ //success
                        return {
                            token: response.data.access_token,
                            refreshToken: response.data.refresh_token,
                            profile: profileFromToken(response.data.access_token)
                        };
                    },
                    function(response) { //failure
                        if (response.status === 401) return fail('incorrect_credentials');
                        else if (Math.floor(response.status / 100) === 4) return fail('client_error', response.data);
                        else return fail('unknown_error', response.data);
                    });
            };

            /**
             * Sends password's data to server that will check if old password matches
             * and then change it with the new one.
             * @param oldPassword  current password of user_id
             * @param newPassword  new password user_id wants to use from now on
             * @returns a promise containing confirmation the password was changed or reason why it wasn't
             */
            self.changePassword = function(oldPassword, newPassword){

                checkRequiredParams({oldPassword: oldPassword, newPassword: newPassword});

                return $http.post(
                    base.url('password/update'),
                    {
                        'old': oldPassword,
                        'new': newPassword
                    },
                    httpConfig
                ).then(
                    // success (200)
                    function(response){
                        // nothing to do here, everything went fine and nothing is returned
                    }, function(response){ // failure
                        if (response.status === 401){ // invalid password
                            throw errorCode.wrap(errorCode.INVALID_CREDENTIALS);
                        }
                        else throw base.unwrapError(response);
                    }, base.unwrapError)
                    .catch(function(error){
                        throw base.mapFields(error, {
                            'new': 'newPassword',
                            'old': 'oldPassword'
                        });
                    });
            };

            /**
             * Request a password reset code for given credentials.
             * The reset code will be delivered by mail or sms.
             * @return a promise to an object containing a method field, being 'email' or 'sms'.
             * @throws rejects the promise with the message 'unknown_user' if the given credentials are not found
             */
            self.passwordResetRequest = function(credentials, recaptchaResponse){

                checkRequiredParams({credentials: credentials, recaptchaResponse: recaptchaResponse});

                var method = 'MAIL';
                if (credentials.indexOf('@') === -1){ // it's a phone number
                    var checkedMsisdn = utils.checkMsisdn(credentials);
                    if (!checkedMsisdn.valid) {
                        throw new Error('This is neither an email address nor a valid phone number');
                    }
                    else {
                        credentials = checkedMsisdn.normalized;
                        method = 'SMS';
                    }
                }
                var data = {credentials: credentials, method: method, recaptcha: recaptchaResponse};
                return $http.post(base.url('password/reset/request'), data, httpConfig)
                    .then(base.unwrapResponse, function(response) {
                        if (response.status === 404)
                            throw errorCode.wrap(errorCode.UNKNOWN_USER);
                        else
                            throw base.unwrapError(response);
                    })
                    .catch(function(error){
                        if (errorCode.is(error, 'customer_identifier_not_unique'))
                            throw errorCode.wrap(errorCode.RESET_BY_EMAIL_IMPOSSIBLE);
                        throw error;
                    });
            };

            /**
             * Perform a password reset based on a code.
             * @param credentials: Credentials identifying the user to reset the password for
             * @param resetCode: the code as the user received by mail or sms
             * @param newPassword: the new password to set for the user
             * @return a promise that should resolve
             * @throws rejects the promise with the message 'invalid_code' if the given credentials are not found
             */
            self.passwordResetPerform = function(credentials, resetCode, newPassword){

                checkRequiredParams({credentials: credentials, resetCode: resetCode, newPassword: newPassword});

                var data = {code: resetCode, password: newPassword};
                if (utils.checkMsisdn(credentials).valid){
                    // Phone number has to be normalized.
                    // Emails are not required, therefor not sent.
                    data['msisdn'] = utils.checkMsisdn(credentials).normalized;
                }
                return $http.post(base.url('password/reset/perform'), data, httpConfig)
                    .then(base.unwrapResponse, function(response) {
                        if (response.status === 401)
                            throw errorCode.wrap(errorCode.INVALID_PHONE_VERIFICATION_CODE);
                        else
                            throw base.unwrapError(response);
                    })
                    .catch(function(error){
                        error = base.mapFields(error, {
                            'password': 'newPassword'
                        });
                        if (errorCode.is(error, errorCode.INVALID_VALUE, 'code')){
                            throw errorCode.wrap(errorCode.INVALID_PHONE_VERIFICATION_CODE);
                        }
                        else
                            throw error;
                    });
            };

            /**
             * Get the account with given customer id.  If the authenticated user
             * has no access, only the email address will be filled in.
             * If no account is found, return null.
             *
             * If no id is passed, the current authenticated user is returned (if any)
             *
             * @returns a promise to the requested account
             */
            self.getCustomer = function(){
                return $http.get(base.url('customers/me'), httpConfig)
                    .then(function(response){
                        return mapCustomerToModel(response.data);
                    }, base.interpretNotFoundAsNull);
            };

            /**
             * Check whether a number is a jim number or not
             * @param msisdn to test
             * @returns {boolean - promise to} whether it is known or not.
             */
            self.isKnownMsisdn = function(msisdn){
                return $http.get(base.url('check-msisdn/{}', msisdn), httpConfig)
                    .then(function(){
                        return true;
                    }, function(){ return false; });
            };

            /**
             * Request a verification for an msisdn.  As a result, the user should receive an sms containing
             * a code.
             *
             * @return a promise which will be resolved when the request is sent.
             */
            self.verifyNumber = function(msisdn, recaptchaResponse){

                checkRequiredParams({msisdn: msisdn, recaptchaResponse: recaptchaResponse});

                var data = {
                    type: 'sms',
                    value: msisdn,
                    recaptcha: recaptchaResponse
                };
                return $http.post(base.url('customers/verify'), data, httpConfig)
                    .then(base.doNothing, base.unwrapError);
            };

            /**
             * Create a new account.
             * @param data an object containing the following keys:
             *  - email
             *  - firstName
             *  - lastName
             *  - dateOfBirth
             *  - title
             *  - address
             *  - company
             *  - vat
             * @param recaptchaResponse a response of a valid recaptcha
             * @param subscriptionData (optional) the msisdn of the pre-existing subscription to link, plus a
             *  verificationCode
             *
             * @returns A promise to the id of the created customer
             */
            self.createCustomer = function(data, recaptchaResponse, subscriptionData){

                checkRequiredParams({data: data, recaptchaResponse: recaptchaResponse});

                var payload = mapCustomerFromModel(data);
                payload.recaptcha = recaptchaResponse;
                if (subscriptionData){
                    payload['phone_number'] = subscriptionData.msisdn;
                    payload['phone_verification_code'] = subscriptionData.verificationCode;
                }
                return $http.post(base.url('customers'), payload, httpConfig)
                    .then(function(response){
                        return response.data.id;
                    }, base.unwrapError)
                    .catch(function(error){
                        throw base.mapFields(error, {});
                    });
            };

            /**
             * @return the current language of the ui, expressed as 'nl' or 'fr' or 'en'
             */
            var currentLanguage = function(){
                return config.language.substr(0, 2).toLowerCase();
            };

            self.updateCustomer = function(data){

                checkRequiredParams({data: data});

                return $http.put(base.url('customers/me'), mapCustomerFromModel(data), httpConfig)
                    .then(base.doNothing, base.unwrapError)
                    .catch(function(error){
                        throw base.mapFields(error, {});
                    });
            };

            /**
             * Save notification settings for a customer or subscription
             * @param notifications notifications to save, expressed as follows:
             *  [
             *     { name: <setting_name>, channels: { sms: <boolean>, mail: <boolean> },
             *     ...
             *  ]
             * @param subscriptionId  The subscription to save for.  If not passed, the settings will be saved at
             *                        customer level.
             * @return A promise that will resolve when the save is complete
             */
            self.saveNotificationSettings = function(notifications, subscriptionId){

                checkRequiredParams({subscriptionId: subscriptionId, notifications: notifications});

                if (subscriptionId)
                    return $http.put(base.url('subscriptions/{}/notification-settings', subscriptionId), notifications,
                        httpConfig)
                        .then(base.doNothing, base.unwrapError);
                else
                    return $q.when({});
                    // TODO: re-enable this when UWA supports customer-level notification settings
                    // return $http.put(base.url('notification-settings'), notifications, httpConfig)
                    //     .then(base.doNothing, base.unwrapError);
            };

            /**
             * @param subscriptionId  The subscripton to retrieve settings for.  If not passed, the customer-level
             *                        settings will be retrieved.
             * @return A promise to the requested settings, expressed as follows:
             *  [
             *     { name: <setting_name>, channels: { sms: <boolean>, mail: <boolean> },
             *     ...
             *  ]
             */
            self.getNotificationSettings = function(subscriptionId){
                if (subscriptionId)
                    return $http.get(base.url('subscriptions/{}/notification-settings', subscriptionId), httpConfig)
                        .then(base.unwrapResponse, base.unwrapError);
                else
                    return $q.when([]);
                    // TODO: re-enable this when UWA supports customer-level notification settings
                    // return $http.get(base.url('notification-settings'), httpConfig)
                    //     .then(base.unwrapResponse, base.unwrapError);
            };

            self.getSubscriptionsForCustomer = function(){
                var mapper = withConfig(mapSubscriptionToModel, httpConfig);
                return $http.get(base.url('subscriptions'), httpConfig)
                    .then(function(response){
                        return $q.all(response.data.map(mapper));
                    }, base.interpretNotFoundAsEmpty, base.unwrapError);
            };

            self.getSubscribersForCustomer = function(){
                return self.getSubscriptionsForCustomer()
                    .then(function(subscriptions){
                        return jim.Subscriber.fromSubscriptions(subscriptions);
                    });
            };

            self.getSubscription = function(subscriptionId){
                checkRequiredParams({subscriptionId: subscriptionId});
                var mapper = withConfig(mapSubscriptionToModel, httpConfig);
                return $http.get(base.url('subscriptions/{}', subscriptionId), httpConfig)
                    .then(function(response){
                        return mapper(response.data);
                    }, base.interpretNotFoundAsNull, base.unwrapError);
            };

            self.getSimState = function(msisdn){
                checkRequiredParams({msisdn: msisdn});
                return $http.get(base.url('sims/{}', msisdn), httpConfig)
                    .then(base.unwrapResponse, base.unwrapError);
            };

            /**
             * Blocks or unblocks a sim card.
             * @param msisdn
             * @param {boolean} block true to block the sim, false to unblock it.
             * @return promise
             */
            self.simBlockSwitch = function(msisdn, block){
                checkRequiredParams({msisdn: msisdn});
                var state= '';
                if (block)
                    state = 'suspended';
                else
                    state = 'enabled';
                return $http.put(base.url('sims/{}', msisdn), {state: state}, httpConfig)
                    .then(base.doNothing, function(response){
                        if (response.status === 422){
                            // The actual error comes as an unable_to_process, but actually,
                            // it is unable because the previous one didn't finish yet.
                            throw errorCode.wrap(errorCode.OTHER_PENDING_PROCESS);
                        }
                        else throw base.unwrapError(response);
                    });
            };

            self.updateAlias = function(subscription, alias){
                checkRequiredParams({alias: alias});
                return $http.put(base.url('sims/{}', subscription.msisdn), {alias: alias}, httpConfig)
                    .then(base.doNothing, base.unwrapError);

            };

            self.getSwapState = function(subscriptionId){
                return $q.when(null);
                /* TODO: not implemented yet in uwa/Comarch
                return $http.get(base.url('subscriptions/{}/sim/swap', subscriptionId), httpConfig)
                    .then(base.unwrapResponse)
                    .then(mapSwapStatusToModel, base.interpretNotFoundAsNull);*/
            };

            /**
             * We mock the result for now as it is not properly returned by the service yet.
             */
            self.requestSimSwap = function(subscriptionId, reason, password, address, firstName, lastName, company,
                block){

                checkRequiredParams({
                    subscriptionId: subscriptionId, reason: reason, password: password,
                    firstName: firstName, lastName: lastName});
                if (block === undefined) block = ['theft', 'loss'].includes(reason);
                var data = {
                    'reason': reason,
                    'password': password,
                    'block_sim': block,
                    'shipping_address': mapShipmentInfoFromModel({
                        firstName: firstName,
                        lastName: lastName,
                        address: address,
                        company: company
                    })
                };

                return $http.post(base.url('subscriptions/{}/sim/swap', subscriptionId), data, httpConfig)
                    .then(function(response){
                        var payload =  {
                            'reason': reason,
                            'status': 'to_be_sent',
                            'shipping_info': {
                                'address': {
                                    'address': address,
                                    'first_name': firstName,
                                    'last_name': lastName,
                                    'company_name': company
                                }
                            }
                        };
                        return mapSwapStateToModel(payload);
                    }, function(error){
                        var data = base.mapFields(error.data);
                        if (error.status === 403 && errorCode.is(error.data, errorCode.ACTION_NOT_AUTHORIZED)) {
                            throw errorCode.wrap(errorCode.SWAP_ALREADY_RUNNING);
                        }
                        if (errorCode.is(data, errorCode.INVALID_VALUE, 'password')){
                            throw errorCode.wrap(errorCode.INVALID_CREDENTIALS);
                        }
                        if (error.status === 409 && errorCode.is(data, errorCode.SWAP_ALREADY_RUNNING)){
                            throw errorCode.wrap(errorCode.SWAP_ALREADY_RUNNING);
                        }
                        base.unwrapError(error);
                    });
            };

            /**
             * Order a new subscription with a sim
             * @param subscriptionProductId string: the ID of the subscription product to purchase
             * @param topupProductId string: the ID of the topup product to purchase (required for prepaid)
             * @param optionProductIds string[]: the IDs of the options to purchase (if any)
             * @param mnpDetails object (optional): an object of iccid, msisdn and operatorId.  Required if mnp is
             *        requested.
             * @param deliveryDetails object: an object containing the company, first and last name, and address for
             *        delivery.
             * @param password: the password to confirm the order
             * @return a promise to a creationResult, containing an orderId and optionally an allowedPaymentMethods.
             *         If the last is given, the order is not complete until paid for. (see payOrder)
             */
            self.orderSubscriptionAndSim = function(subscriptionProductId, topupProductId, optionProductIds, mnpDetails,
                                                    deliveryDetails, password){

                checkRequiredParams({subscriptionProductId: subscriptionProductId, password: password,
                    deliveryDetails: deliveryDetails});

                var children = [];
                if (topupProductId)
                    children.push(topupProductId);
                if (optionProductIds)
                    children.push.apply(children, optionProductIds);


                var data = {
                    'product_id': subscriptionProductId,
                    'child_product_ids': children,
                    'password': password,
                    'shipping_address': mapShipmentInfoFromModel(deliveryDetails)
                };

                if (mnpDetails) {
                    data['sim_info'] = {donor: mapMnpDetailsFromModel(mnpDetails)};
                }
                return $http.post(base.url('subscriptions'), data, httpConfig)
                    .then(base.unwrapResponse)
                    .then(base.snakeToCamel, base.unwrapError);
            };

            /**
             * Create a new order
             * @param subscriptionId Id of the subscription to order for
             * @param productId Id of the product to buy
             * @param childProductIds any extra child products to add to the order (optional)
             * @param password the password for the order (optional, though some types of orders might require it)
             * @return a promise for the created order.  This could be pending or active.  The order will be an
             *  object with the keys orderId, state, and allowedPaymentMethods (optional)
             */
            self.createOrder = function(subscriptionId, productId, childProductIds, password){

                checkRequiredParams({subscriptionId: subscriptionId, productId: productId});

                var data = {
                    'subscription_id': subscriptionId,
                    'product_id': productId
                };
                if (childProductIds && childProductIds.length > 0)
                    data['child_product_ids'] = childProductIds;
                if (password)
                    data['password'] = password;
                return $http.post(base.url('orders'), data, httpConfig)
                    .then(base.unwrapResponse, base.unwrapError).then(base.snakeToCamel)
                    .then(mapOrderToModel)
                    .catch(function(error){
                        if (errorCode.is(error, errorCode.INVALID_GRANT))
                            throw errorCode.wrap(errorCode.INVALID_CREDENTIALS);
                        if (errorCode.is(error, errorCode.INVALID_VALUE, 'password'))
                            throw errorCode.wrap(errorCode.INVALID_CREDENTIALS);
                        throw error;
                    });
            };

            self.getOrder = function(orderId) {
                checkRequiredParams({orderId: orderId});
                return $http.get(base.url('orders/{}', orderId), httpConfig)
                    .then(base.unwrapResponse, base.interpretNotFoundAsNull)
                    .then(mapOrderToModel);
            };

            self.getOrders = function(page, recordsPerPage, subscriptionId) {
                if (!page) page = 1;
                if (!recordsPerPage) recordsPerPage = 20;

                var params = {'page': page, 'per_page': recordsPerPage};
                if (subscriptionId) params['subscription_id'] = subscriptionId;

                return $http.get(base.url('orders', params), httpConfig)
                    .then(unwrapPagedResponse(mapOrderToModel), base.unwrapError);
            };

            /**
             *
             * @param state an array of states we want to filter on
             * @param subscriptionId string (optional)
             * @return {*} a promise to an array of orders matching the provided sates
             */
            self.getOrdersInState = function(state, subscriptionId){

                checkRequiredParams({state: state});

                var params = {
                    'status': state.join(','),
                    'per_page': 10000 // we take a very high amount to get rid of paging here
                };
                if (subscriptionId)
                    params['subscription_id'] = subscriptionId;
                return $http.get(base.url('orders', params), httpConfig)
                    .then(unwrapPagedResponse(mapOrderToModel), base.unwrapError);
            };

            /**
             * @param type an array of types you want to filter on
             * @param state an array of states you want to filter on
             * @param subscriptionId string (optional)
             * @return a promise to an array of orders matching the provided filters
             */
            self.getTypedOrdersInState = function(type, state, subscriptionId){

                checkRequiredParams({state: state, type: type});

                var params = {
                    'type': type.join(','),
                    'status': state.join(',')
                };
                if (subscriptionId) params['subscription_id'] = subscriptionId;
                return $http.get(base.url('orders', params), httpConfig)
                    .then(unwrapPagedResponse(mapOrderToModel), base.unwrapError);
            };

            /**
             * Get all pending (non-final) orders.
             */
            self.getPendingOrders = function(subscriptionId){
                /*
                    Note: due to a bug in comarch/uwa, we don't get the activation orders under the correct subscription
                    id.  So for the moment we do the filtering locally.  We never expect a large amount of pending
                    orders anyway.

                    If we encounter an activation process in mnp_rejected, we will consider the parent order
                    to be mnp_rejected as well.
                 */
                var states = jim.values(jim.OrderState)
                    .except(jim.OrderState.cancelled, jim.OrderState.failed, jim.OrderState.enabled);
                var params = {
                    'status': states.join(','),
                    'per_page': 10000 // we take a very high amount to get rid of paging here
                };
                return $http.get(base.url('orders', params), httpConfig)
                    .then(unwrapPagedResponse(mapOrderToModel), base.unwrapError)
                    .then(function(orders){
                        var myOrders = orders.filter(function(order){
                            return !subscriptionId || subscriptionId === order.subscriptionId;
                        });

                        var mnpRejectParentIds = orders
                            .filter(function(order){ return order.type === jim.OrderType.SIM_ACTIVATION; })
                            .filter(function(order){ return order.state === jim.OrderState.mnp_rejected; })
                            .filter(function(order){ return order.parentOrderId; })
                            .map(function(order){ return order.parentOrderId; });

                        myOrders.forEach(function(order){
                            if (mnpRejectParentIds.includes(order.id))
                                order.state = jim.OrderState.mnp_rejected;
                        });

                        return myOrders;
                    });
            };

            /**
             * Activate an existing sim.
             * @param iccid ICCID of the sim to activate
             */
            self.activateSubscription = function(iccid){

                checkRequiredParams({iccid: iccid});

                var data = {iccid: iccid};
                return $http.post(base.url('sims/activate'), data, httpConfig)
                    .then(base.unwrapResponse)
                    .catch(function(response){
                        var data = base.mapFields(response.data);
                        if (response.status === 403) {
                            if (errorCode.is(data, errorCode.ACTION_NOT_AUTHORIZED))
                                throw errorCode.wrap(errorCode.ALREADY_ACTIVATING);
                        }
                        if (response.status === 400) {
                            if (errorCode.is(data, errorCode.INVALID_VALUE, 'iccid'))
                                throw errorCode.wrap(errorCode.UNKNOWN_SIM);
                        }
                        if (response.status === 404) {
                            // this is a temporary fix, awaiting uwa to align.
                            throw errorCode.wrap(errorCode.UNKNOWN_SIM);
                        }
                        throw base.unwrapError(response);
                    });
            };

            self.cancelSubscription = function(id, password){

                checkRequiredParams({id: id, password: password});

                var data = {password: password};
                return $http.post(base.url('subscriptions/{}/cancel', id), data, httpConfig)
                    .catch(base.unwrapError)
                    .catch(function(error){
                        if (errorCode.is(error, errorCode.INVALID_GRANT))
                            throw errorCode.wrap(errorCode.INVALID_CREDENTIALS);
                        if (errorCode.is(error, errorCode.INVALID_VALUE, 'password'))
                            throw errorCode.wrap(errorCode.INVALID_CREDENTIALS);
                        throw error;
                    });
            };

            self.updateMnpDetails = function(orderId, mnpDetails){
                checkRequiredParams({orderId: orderId, mnpDetails: mnpDetails});

                var data = mapMnpDetailsFromModel(mnpDetails);
                return $http.put(base.url('orders/{}/donor', orderId), data, httpConfig)
                    .catch(base.unwrapError);
            };

            /**
             * Set up a payment method for a subscription.  This can result in an initial payment being needed
             * @param subscriptionId: subscription to set up the payment for
             * @param paymentMethod: selected method (an object containing either a paymentProvider or a
             *          mandateId, or neither to remove the payment)
             * @param redirectUrl: if an initial payment is required, the url to redirect to afterwards
             * @param topupOptions to add for auto-topup, if relevant
             */
            self.setupPayment = function(subscriptionId, paymentMethod, redirectUrl, topupOptions){

                checkRequiredParams({subscriptionId: subscriptionId});

                var data = {};
                if (redirectUrl)
                    data ['redirect_url'] = redirectUrl;
                if (topupOptions){
                    data['sms_trigger'] = false;
                    data['auto_topup'] = {
                        'topup_product_id': topupOptions.productId,
                        'amount_threshold': topupOptions.amountThreshold,
                        'on_amount_threshold': topupOptions.onAmountThreshold === true,
                        'on_bundle_expiry': topupOptions.onBundleExpiry === true,
                        'on_low_data': topupOptions.onLowData === true
                    };
                }
                data['mandate_id'] = (paymentMethod.mandateId) ? paymentMethod.mandateId : '';
                return $http.put(base.url('subscriptions/{}/payment-settings', subscriptionId), data, httpConfig)
                    .then(function(response){
                        return {
                            paymentUrl: response.data.payment_url
                        };
                    }, base.unwrapError);
            };

            self.removeMandate = function(mandateId){
                checkRequiredParams({mandateId: mandateId});
                return $http.delete(base.url('mandates/{}', mandateId), httpConfig)
                    .catch(base.unwrapError);
            };

            self.linkMandate = function(subscriptionId, mandateId){
                checkRequiredParams({mandateId: mandateId, subscriptionId: subscriptionId});
                return $http.post(base.url('mandates/{}/link', mandateId),
                    {'subscription_id': subscriptionId}, httpConfig)
                    .catch(base.unwrapError);
            };

            self.unlinkMandate = function(subscriptionId, mandateId){
                checkRequiredParams({mandateId: mandateId, subscriptionId: subscriptionId});
                var reqConfig = angular.copy(httpConfig);
                reqConfig.data = {'subscription_id': subscriptionId};
                reqConfig.headers['Content-Type'] = 'application/json';
                return $http.delete(base.url('mandates/{}/link', mandateId), reqConfig)
                    .catch(base.unwrapError);
            };

            self.requestNewMandate = function(subscriptionId, redirectUrl, method, providerOptions){

                checkRequiredParams({subscriptionId: subscriptionId, redirectUrl: redirectUrl, method: method});

                var data = {
                    'subscription_id': subscriptionId,
                    'redirect_url': redirectUrl,
                    'method': method
                };
                for (var key in providerOptions){
                    data[key] = providerOptions[key];
                }
                return $http.post(base.url('mandates/request'), data, httpConfig).then(function(response){
                    return {
                        paymentUrl: response.data['mandate_request_url']
                    };
                }, function(error){
                    if (error.status === 400 && errorCode.is(error.data, errorCode.MANDATE_UNSETTABLE)){
                        throw errorCode.wrap(errorCode.MANDATE_UNSETTABLE);
                    }
                    else {
                        base.unwrapError(error);
                    }
                });
            };

            /**
             * Retrieve mandates for the given customer
             */
            self.getMandates = function(){
                return $http.get(base.url('mandates'), httpConfig)
                    .then(base.unwrapResponse, base.interpretNotFoundAsEmpty)
                    .then(base.snakeToCamel)
                    .then(function(mandates) {
                        return mandates.filter(function(mandate){
                            return !['disabled', 'deleted', 'expired'].includes(mandate.state);
                        });
                    });
            };

            self.getPaymentSetup = function(subscriptionId) {
                checkRequiredParams({subscriptionId: subscriptionId});
                return $http.get(base.url('subscriptions/{}/payment-settings', subscriptionId), httpConfig)
                    .then(base.unwrapResponse, base.interpretNotFoundAsNull).then(base.snakeToCamel);
            };

            self.getTopupHistory = function(subscriptionId, filters){
                checkRequiredParams({subscriptionId: subscriptionId});
                var params = filtersToParamsObject(filters);
                return $http.get(base.url('subscriptions/{}/topups', params, subscriptionId), httpConfig)
                    .then(unwrapPagedResponse(mapTopupToModel), base.unwrapError)
                    .then(function(topups){
                        var filtered = topups.filter(function(t){ return t.state === 'enabled'; });
                        filtered.paging = topups.paging;
                        return filtered;
                    });
            };

            self.getInvoicingSettings = function(subscriptionId){
                checkRequiredParams({subscriptionId: subscriptionId});
                return $http.get(base.url('subscriptions/{}/invoicing-settings', subscriptionId), httpConfig)
                    .then(base.unwrapResponse, base.unwrapError)
                    .then(function(payload){
                        return {
                            billingPreference: payload['billing_preference'],
                            invoicingAddress: mapShipmentInfoToModel(payload['invoicing_address'])
                        };
                    });
            };

            self.setInvoicingSettings = function(subscriptionId, invoicingSettings){

                checkRequiredParams({subscriptionId: subscriptionId, invoicingSettings: invoicingSettings});

                var data = {
                    'billing_preference': invoicingSettings.billingPreference,
                    'invoicing_address': mapShipmentInfoFromModel(invoicingSettings.invoicingAddress)
                };
                return $http.put(base.url('subscriptions/{}/invoicing-settings', subscriptionId), data, httpConfig)
                    .then(base.unwrapResponse, base.unwrapError);
            };

            /**
             * Transforms the filters object given by FE into a params object used to construct the request url
             * @param filters
             * @returns {{}}
             */
            var filtersToParamsObject = function(filters){

                // keys are given by FE and values are actual (UWA) parameters name.
                var availableFilters = {
                    type: 'type',
                    dateFrom: 'from_date',
                    dateTo: 'until_date',
                    pageNumber: 'page',
                    perPage: 'per_page'
                };

                var result = {};

                for (var filter in filters) {
                    if (filters[filter]) {
                        if (filter in availableFilters) {
                            result[availableFilters[filter]] = base.formatDateIfNeeded(filters[filter]);
                        }
                        else {
                            throw new Error('unsupported filter' + filter);
                        }
                    }
                }
                return result;
            };


            /**
             * Get usage history
             * @param subscriptionId subscription to retrieve history for
             * @param filters any filters to use.  (not implemented yet)
             * @param page the page of history to retrieve. The first page is 1.
             * @param perPage number of records per page.  Defaults to 20.
             * @return A promise to an array of usage history.  The array will have a 'paging' property
             *  that contains info on the previous and next pages.
             */
            self.getUsageHistory = function(subscriptionId, filters, page, perPage){

                checkRequiredParams({subscriptionId: subscriptionId});

                if (!filters) filters = {};

                filters = {
                    /* TODO: re-enable this when UWA supports filtering usage-records
                    type: filters.type === 'ALL' ? undefined : filters.type, */
                    'from_date': base.formatDate(filters.dateFrom),
                    'until_date': base.formatDate(filters.dateTo),
                    'page': page,
                    'per_page': perPage || 20
                };

                return $http.get(base.url('subscriptions/{}/usage', filters, subscriptionId), httpConfig)
                    .then(unwrapPagedResponse(mapUsageRecordToModel), base.unwrapError);
            };

            self.getUsageTotals = function(subscriptionId, filters){
                checkRequiredParams({subscriptionId: subscriptionId});

                var filterQuery = {};
                if (!filters) filters = {};

                filterQuery = {
                    /* TODO: re-enable this when UWA supports filtering usage-records
                    type: filters.type === 'ALL' ? undefined : filters.type, */
                    'from_date': base.formatDate(filters.dateFrom),
                    'until_date': base.formatDate(filters.dateTo)
                };

                var url = base.versionedUrl('20190729', 'subscriptions/{}/usage-summary', filterQuery, subscriptionId);
                return $http.get(url, httpConfig)
                    .then(base.unwrapResponse, base.unwrapError)
                    .then(base.snakeToCamel)
                    .then(filterRegionality)
                    .then(mapUsageTotalsToModel);

                function filterRegionality(records){
                    if (!filters.regionality) return records;
                    return records.filter(function(record){ return record.regionality === filters.regionality; });
                }
            };

            self.getInvoiceHistory = function(page){
                return $http.get(base.url('invoices', {page: page}), httpConfig)
                    .then(unwrapPagedResponse(mapInvoiceToModel), base.unwrapError);
            };

            /**
             * Gets invoices filtered by status. Paid or unpaid.
             * what we consider as paid is mapped to paid only for now.
             * @param page int, the page number you want.
             * @param paid boolean. If true, will return paid invoices if false, unpaid ones.
             * @return a promise to a page of filtered (paid|unpaid) invoices.
             */
            self.getInvoicesByState = function(page, paid){
                var state = paid ? 'paid' : 'issued';
                return $http.get(base.url('invoices', {'page': page, 'status': state}), httpConfig)
                    .then(unwrapPagedResponse(mapInvoiceToModel), base.unwrapError);
            };

            self.payInvoice = function(invoiceId, redirectUrl){

                checkRequiredParams({invoiceId: invoiceId, redirectUrl: redirectUrl});

                var data = {
                    'invoice_id': invoiceId,
                    'redirect_url': redirectUrl
                };
                return $http.post(base.url('pay'), data, httpConfig)
                    .then(base.unwrapResponse, base.unwrapError).then(base.snakeToCamel);
            };

            self.payOrder = function(orderId, redirectUrl, paymentMethod){

                checkRequiredParams({orderId: orderId, redirectUrl: redirectUrl, paymentMethod: paymentMethod});

                var data = {
                    'order_id': orderId,
                    'redirect_url': redirectUrl,
                    'payment_method': paymentMethod
                };

                return $http.post(base.url('pay'), data, httpConfig)
                    .then(base.unwrapResponse, base.unwrapError).then(base.snakeToCamel);
            };

            // Product catalog __________________________________

            self.getProduct = function(id){
                checkRequiredParams({id: id});
                return $http.get(base.url('products/{}', id), httpConfig)
                    .then(base.unwrapResponse)
                    .then(mapProductToModel, base.interpretNotFoundAsNull);
            };

            self.getProductsByType = function(type, includeLegacy){
                if (!type) return self.getProducts(includeLegacy);

                checkRequiredParams({type: type});

                var query = {'type': type};
                if (includeLegacy) query['include_legacy'] = 'true';

                return $http.get(base.url('products', query), httpConfig)
                    .then(base.unwrapResponse, base.unwrapError)
                    .then(function (entries) {
                        return entries.map(mapProductToModel);
                    });
            };

            /**
             * @return {*}
             */
            self.getProducts = function(includeLegacy){
                var query = [];
                if (includeLegacy) query['include_legacy'] = 'true';
                return $http.get(base.url('products', query), httpConfig)
                    .then(base.unwrapResponse, base.unwrapError)
                    .then(function(entries){
                        return entries.map(mapProductToModel);
                    });
            };

            /**
             * @return a promise to the list of viable products for the given parent.
             */
            self.getProductsForParent = function(parentId) {
                checkRequiredParams({parentId: parentId});
                return $http.get(base.url('products', {'product_id': parentId}), httpConfig)
                    .then(base.unwrapResponse, base.unwrapError)
                    .then(function(entries){
                        return entries.map(mapProductToModel);
                    });
            };

            self.getOperators = function(){
                return $http.get(base.url('operators'), httpConfig)
                    .then(base.unwrapResponse)
                    .then(function(entries){
                        return entries.map(function(entry){
                            return {id: entry.name, name: entry.name, iins: entry.iins};
                        }).sort(function(one, two){
                            return one.name.localeCompare(two.name);
                        });
                    }, base.unwrapError);
            };

            /**
             * @return a handle to the client which will authenticate all calls with the given token.
             * This can be used to force authentication for a specific subset of calls.
             */
            self.authenticatedWith = function(token){

                var authenticated = function(target, fnc, token){
                    return function(){
                        setHeader('Authorization', 'Bearer '+token);
                        var response = target[fnc].apply(target, arguments);
                        setHeader('Authorization', undefined);
                        return response;
                    };
                };

                var result = {};
                for (var fnc in self) {
                    if (self.hasOwnProperty(fnc) && typeof self[fnc] === 'function'){
                        result[fnc] = authenticated(self, fnc, token);
                    }
                }
                return result;
            };

            /**
             * Decorate a function so that it will run with a specific httpConfig.
             * @param fnc
             */
            var withConfig = function(fnc, configToUse){
                configToUse = angular.copy(configToUse);
                return function(){
                    var original = httpConfig;
                    httpConfig = configToUse;
                    var result = fnc.apply(this, arguments);
                    httpConfig = original;
                    return result;
                };
            };

            /**
             * Set a header to be passed in with every request.  Set it to undefined to remove again.
             */
            var setHeader = function(header, value){
                if (value === undefined)
                    delete httpConfig.headers[header];
                else
                    httpConfig.headers[header] = value;
            };

            /**
             * Parse a token, and if it is a JWT, extract the profile information from it
             */
            var profileFromToken = function(token){
                try {
                    var parts = token.split('.');
                    if (parts.length !== 3) throw new Error('Token does not have three parts');
                    var claims = JSON.parse(atob(parts[1]));
                    return {
                        name: claims.name,
                        phone: claims.phone,
                        email: claims.email,
                        customerId: claims.customerId
                    };
                }
                catch (error){
                    $log.warn('Token not a well-formed JWT.  Not parsing profile data.');
                    $log.warn(error);
                    return {};
                }
            };

            /**
             * Take a link header (see https://tools.ietf.org/html/rfc5988) and interpret it for paging.
             * A link like http://here?page=3 rel=prev will result in prev:3
             * see https://developer.github.com/v3/#pagination.
             */
            var parsePagingLinks = function(linkHeader) {
                if (!linkHeader) return {};
                var links = linkHeader.split(',');
                var result = {};
                for (var i=0; i<links.length; i++){
                    var match = /<.*(?:\?|&)page=(\d*).*>;\s*rel="(prev|next|first|last)"/.exec(links[i]);
                    if (match) {
                        result[match[2]] = match[1];
                    }
                }
                return result;
            };

            /**
             * Build a function that will take a paged response and return it as an array with 'paging' property set.
             * @param rowMapper mapper to use for the result rows.
             */
            var unwrapPagedResponse = function(rowMapper) {
                return function(response){
                    var result = response.data.results.map(rowMapper);
                    result.paging = parsePagingLinks(response.headers('Link'));
                    return result;
                };
            };

            /**
             * Check if the given parameters are correctly passed.  This will throw if one of the values is undefined.
             *
             * Intended as a sanity-check to prevent Jim bugs from leaking into UWA.
             *
             * @param requiredParams The parameters, as an object with the param name as a key, and value as a value.
             */
            var checkRequiredParams = function(requiredParams){
                var paramNames = Object.keys(requiredParams);
                for (var i = 0; i < paramNames.length; i++){
                    if (requiredParams[paramNames[i]] === undefined)
                        throw new Error('Required parameter missing: '+paramNames[i]);
                }
            };

        }]);
